// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root_fPSEY","dividing":"Tabs_dividing_sFT1D"};